<template>
  <div>
    <Head :title="form.name" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-blue-400 hover:text-blue-600" href="/systems">Systems</Link>
        <span class="text-blue-400 font-medium">/</span>
        {{ form.name }}
      </h1>
      <img v-if="system.img" class="block ml-4 w-8 h-8 " :src="system.img" />
    </div>
    <trashed-message v-if="system.deleted_at" class="mb-6" @restore="restore"> This system has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white  shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full" label="Name" />
          <textarea-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full" label="Description" />
          <file-input v-model="form.img" :error="form.errors.img" class="pb-8 pr-6 w-full" type="file" accept="image/*" label="Image" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="! system.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete System</button>
          <loading-button :loading="form.processing" class="btn-blue ml-auto" type="submit">Update System</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    FileInput,
    TextInput,
    TextareaInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    system: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name : this.system.name,
        description: this.system.description,
        img: null,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/systems/${this.system.id}`, {
        onSuccess: () => this.form.reset('img'),
      })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this system?')) {
        this.$inertia.delete(`/systems/${this.system.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this system?')) {
        this.$inertia.put(`/systems/${this.system.id}/restore`)
      }
    },
  },
}
</script>
